export default ({ account }) => {
  return {
    get(type) {
      return account.getMeta('autocompletion_' + type, []).filter(item => typeof item === 'string')
    },

    add (type, value) {
      value = value.trim().toLowerCase()
      const values = this.get(type)
      if (values.indexOf(value) === -1) {
        values.push(value)
        account.setMeta('autocompletion_' + type, values)
      }
    },

    remove (type, value) {
      value = value.trim().toLowerCase()
      const values = this.get(type)
      const index = values.indexOf(value)
      if (index !== -1) {
        values.splice(index, 1)
        account.setMeta('autocompletion_' + type, values)
      }
    },

    purge (type) {
      account.setMeta('autocompletion_' + type, [])
    }
  }
}